import * as util from 'util';
import _ from 'lodash';
import {Component, OnInit, ViewChild} from "@angular/core";
import {ClipboardService} from "ngx-clipboard";
import {ChartComponent} from "ng-apexcharts";
import {DomSanitizer} from "@angular/platform-browser";
import {NotificationService} from "../../../../services/notificationService";
import {LookAndFeelService} from "../../../../services/lookAndFeelService";
import {RouteService} from "../../../../services/routeService";
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";

@Component({
	selector: 'account-compromised-rules-configurations',
	templateUrl: './account-compromised-rules-configurations.component.html',
})
export class AccountCompromisedRulesConfigurationsComponent implements OnInit {
	constructor(public gs:GeneralService,
				private rs:RouteService,
				private sanitizer:DomSanitizer,
				private lfs:LookAndFeelService,
				private ns:NotificationService,
				private clipboard: ClipboardService){
	}

	@ViewChild('emailsDetectedChart', {static: false}) emailsDetectedChart: ChartComponent;
	@ViewChild('topSendersChart', {static: false}) topSendersChart: ChartComponent;
	@ViewChild('topRecipientMailboxesChart', {static: false}) topRecipientMailboxesChart: ChartComponent;

	dic = DICTIONARY;

	viewTypes = {chart: 'Chart', list: 'List'};

	trendsPeriod = [
		this.dic.CONSTANTS.trendsPeriod.lastDay,
		this.dic.CONSTANTS.trendsPeriod.last3Days,
		this.dic.CONSTANTS.trendsPeriod.lastWeek,
		this.dic.CONSTANTS.trendsPeriod.lastMonth,
	];

	userInfo;
	rules;
	newRule;
	getRulesDataInProcess
	createNewRulesInProcess;
	prepareRuleInProcess;
	ruleUsagePopup;
	getRuleUsageInProcess;
	emailDetectedByRuleChartOptions;
	senderGraphOptions;
	recipientGraphOptions;
	ruleEmailIdCopied;
	invalidRuleName;
	invalidResults = false;
	sensitivity_types;

	users;
	getAccountCompromisedInProcess;

	searchResultsText = '';
	searchResultNotFound = false;

	ngOnInit() {
		this.gs.getUserInfo(false, (userInfo) => {
			this.userInfo = userInfo;
		});

		this.getRulesDataInProcess = true;
		this.rs.getAccountCompromisedRules().then( (response) => {
			this.rules = response.rules;
			this.users = response.users;

			this.parseRulesResultAndExceptions(this.rules);
			this.getRulesDataInProcess = false;
		}, (err) => {
			this.getRulesDataInProcess = false;
		});
	};

	createNewRule = () => {
		this.newRule = {
			conditions: [
				[this.getNewCondition()]
			],
			exceptions: [],
			result: _.cloneDeep(this.dic.CONSTANTS.accountCompromisedRule.defaultResult),
			resultShow: []
		};

		this.createNewRulesInProcess = true;
		this.isResultChanged();
	};

	addExceptionToRule() {
		if (!this.newRule.exceptions) {
			this.newRule.exceptions = [];
		}
		this.newRule.exceptions.push([this.getNewException()]);
	};

	addConditionToRule() {
		this.newRule.conditions.push([this.getNewCondition()]);
	};

	addORtoCondition = (condition, isException) => {
		if (isException) {
			condition.push(this.getNewException());
		}
		else {
			condition.push(this.getNewCondition());
		}
	}

	getNewCondition = () => {
		const newCondition:any = _.cloneDeep(this.dic.CONSTANTS.accountCompromisedRule.defaultCondition);
		newCondition.data.incidentTypes = Object.keys(this.dic.CONSTANTS.accountCompromisedIncidentTypes).map(incidentTypeKey => ({
			key: incidentTypeKey,
			selected: false,
			...this.dic.CONSTANTS.accountCompromisedIncidentTypes[incidentTypeKey]
		}));
		return newCondition;
	}

	getNewException = () => {
		const newCondition:any = _.cloneDeep(this.dic.CONSTANTS.accountCompromisedRule.defaultExcept);
		newCondition.data.users = this.users.map(user => ({
			...user,
			selected: false,
		}));
		return newCondition;
	}

	showRuleActions = () => {
		return [
			this.dic.CONSTANTS.compromisedRulesActions.edit,
			this.dic.CONSTANTS.compromisedRulesActions.clone,
			this.dic.CONSTANTS.compromisedRulesActions.delete
		];
	}

	selectRuleAction = (rule, action) => {
		switch (action) {
			case this.dic.CONSTANTS.compromisedRulesActions.edit:
				this.startEditRule(rule);
				break;

			case this.dic.CONSTANTS.compromisedRulesActions.clone:
				this.cloneRule(rule);
				break;

			case this.dic.CONSTANTS.compromisedRulesActions.delete:
				this.openDeleteRulePopup(rule);
				break;
		}
	}

	selectMultipleRulesAction = (selectedRules, action) => {
		switch(action) {
			case this.dic.CONSTANTS.rulesActions.delete:
				this.openDeleteRulesPopup(selectedRules);
				break;

			case this.dic.CONSTANTS.rulesActions.enable:
				this.updateRuleState(selectedRules, true);
				break;

			case this.dic.CONSTANTS.rulesActions.disable:
				this.updateRuleState(selectedRules, false);
				break;

		}
	}
	showMultipleRulesActions = () => {
		return [
			this.dic.CONSTANTS.rulesActions.enable,
			this.dic.CONSTANTS.rulesActions.disable,
			this.dic.CONSTANTS.rulesActions.delete
		];
	}

	searchRule = (searchTerm, activeFilters) => {
		this.rules.forEach(record => {
			// search
			const isFound = searchTextExecute(record, searchTerm);
			if (!isFound) {
				record.hide = true;
				return;
			}

			// filter
			// no filters in this table

			record.hide = false;
		});

	}

	updateRulePriority = (dragItem, draggedOnTopItem=null) => {
		if (!dragItem) {
			return;
		}

		const isMoveForward = draggedOnTopItem && this.rules.indexOf(draggedOnTopItem) > this.rules.indexOf(dragItem);

		const moveToIndex = draggedOnTopItem ? this.rules.indexOf(draggedOnTopItem) - (isMoveForward ? 1 : 0) : this.rules.length - 1;

		const ruleData:any = {
			action: this.dic.CONSTANTS.accountCompromisedRule.actions.move,
			idx: moveToIndex
		};

		this.rs.updateAccountCompromisedRule(dragItem._id, ruleData).then(response => {
			this.rules = response.rules;
			this.parseRulesResultAndExceptions(this.rules);
			this.ns.overwriteMessage(null, this.dic.MESSAGES.rulePriorityUpdated);
		});
	}

	updateRuleState = (rules, action) => {
		rules.forEach(rule => {
			const ruleData = {
				action: this.dic.CONSTANTS.accountCompromisedRule.actions.toggleState,
				enabled: action
			};

			this.rs.updateAccountCompromisedRule(rule._id, ruleData).then(response => {
				rule.enabled = ruleData.enabled;
			});
		});
	};

	parseRulesResultAndExceptions = (rules) => {
		for (let i = 0; i < rules.length; i++) {
			rules[i].priority = i; // starts from 0
			rules[i].priorityDisplay = this.gs.addOrdinalNumberSuffix(i + 1);

			if (rules[i].conditions?.length) {
				// make all conditions arrays of conditions
				rules[i].conditions = _.map(rules[i].conditions, condition => {
					if (condition.or_conditions?.length) {
						return condition.or_conditions
					}
					else {
						return [condition]
					}
				});

				rules[i].conditions.forEach(conditionArr => {
					conditionArr.forEach(cond =>{
						this.getRuleConditionText(cond);
					});
				});
			}

			if (rules[i].exceptions?.length) {
				// make all conditions arrays of conditions
				rules[i].exceptions = _.map(rules[i].exceptions, condition => {
					if (condition.or_conditions?.length) {
						return condition.or_conditions
					}
					else {
						return [condition]
					}
				});

				rules[i].exceptions.forEach(conditionArr => {
					conditionArr.forEach(cond =>{
						this.getRuleConditionText(cond);
					});
				});
			}

			if (!rules[i].result) continue;
			rules[i].resultShow = [];
			_.each(Object.keys(rules[i].result), (key) => {
				if (rules[i].result[key]) {
					rules[i].resultShow.push(this.dic.CONSTANTS.accountCompromisedRule.defaultResult[key].label);
				}
			});
		}
	};

	resetNewRuleData = () => {
		this.newRule = null;
		this.createNewRulesInProcess = false;
		this.prepareRuleInProcess = false;
	};

	cancelNewRule() {
		this.resetNewRuleData();
	};

	cloneRule(rule) {
		this.newRule = _.cloneDeep(rule);
		this.setRuleForEdit();
		this.newRule._id = null;
		this.newRule.name = `Clone of ${rule.name}`;
		this.createNewRulesInProcess = true;
		this.isResultChanged();
	}

	startEditRule(rule) {
		this.newRule = _.cloneDeep(rule);
		this.setRuleForEdit();
		this.createNewRulesInProcess = true;
		this.isResultChanged();
	};

	showRulesUsage = (ruleObj) => {
		this.ns.showWarnMessage('Not supported yet...');
		return;

		this.ruleUsagePopup = {
			ruleObj,
			usagePeriod: DICTIONARY.CONSTANTS.trendsPeriod.lastWeek,
			viewType: this.viewTypes.chart,
			emails: [],
			show: true
		};
		this.getRuleUsage(ruleObj);
	};

	getRuleUsage = (ruleObj) => {
		this.getRuleUsageInProcess = true;

		const ruleData = {
			action: this.dic.CONSTANTS.accountCompromisedRule.actions.usage,
			period: this.ruleUsagePopup.usagePeriod.value,
			size: this.dic.CONSTANTS.quarantinedEmailsFirstBatchSize,
		};

		this.rs.updateAccountCompromisedRule(ruleObj._id.toString(), ruleData).then(response => {
			this.ruleUsagePopup.emails = response?.emails || [];

			this.prepareGraphInfo(false);
			this.getNextEmailsBatch(ruleObj, response, () => {
				this.getRuleUsageInProcess = false;
			});

		}, (err) => {
			this.getRuleUsageInProcess = false;
		});
	};

	prepareGraphInfo = (isUpdate) => {
		this.prepareEmailsRuleChart(this.ruleUsagePopup.ruleObj, this.ruleUsagePopup.emails, isUpdate);
		this.getEmailSenderChartInfo(this.ruleUsagePopup.emails, isUpdate);
		this.getEmailRecipientChartInfo(this.ruleUsagePopup.emails, isUpdate);
	}

	getNextEmailsBatch = (ruleObj, quarantineInfo, cb) => {
		if (!quarantineInfo.lastCreated) {
			return cb();
		}

		const ruleData = {
			action: this.dic.CONSTANTS.accountCompromisedRule.actions.usage,
			period: this.ruleUsagePopup.usagePeriod.value,
			size: this.dic.CONSTANTS.quarantinedEmailsBatchSize,
			lastCreated: quarantineInfo.lastCreated
		};

		this.rs.updateAccountCompromisedRule(ruleObj._id.toString(), ruleData).then(response => {
			if (response.emails?.length) {
				this.ruleUsagePopup.emails = this.ruleUsagePopup.emails.concat(response.emails);
				this.prepareGraphInfo(true);
			}

			this.getNextEmailsBatch(ruleObj, response, cb);
		});
	}

	prepareEmailsRuleChart = (ruleObj, emails, isUpdate) => {

		const ruleUsage = {
			total: emails.length,
			labels: [],
			data: [[]],
			series: [ruleObj.name]
		};

		// @ts-ignore
		emails.sort((a, b) => new Date(a.created) - new Date(b.created));

		let rulesSourcePerWeek = {
			dateStart: null,
			dateEnd: null,
			total: 0,
		};

		for (let i = 0; i < emails.length; i++) {
			let currentSource = emails[i];

			if (!rulesSourcePerWeek.dateStart) {
				rulesSourcePerWeek = this.gs.calcDatesForPeriod(currentSource, this.ruleUsagePopup.usagePeriod.value);
				rulesSourcePerWeek.total = 0;
			}

			if (this.gs.isSamePeriod(this.ruleUsagePopup.usagePeriod.value, currentSource.created, rulesSourcePerWeek.dateEnd)) {
				rulesSourcePerWeek.total += 1;
			}
			else {
				this.addCompromisedRuleUsageData(ruleUsage, rulesSourcePerWeek, this.ruleUsagePopup.usagePeriod.value);

				rulesSourcePerWeek = this.gs.calcDatesForPeriod(currentSource, this.ruleUsagePopup.usagePeriod.value);
				rulesSourcePerWeek.total = 0;

				rulesSourcePerWeek.total += 1;
			}
		}
		this.addCompromisedRuleUsageData(ruleUsage, rulesSourcePerWeek, this.ruleUsagePopup.usagePeriod.value);


		const series = [];
		ruleUsage.series.forEach((categoryName, index) => {
			series.push({
				name: 'Emails',
				data: ruleUsage.data[index]
			});
		});

		if (isUpdate && this.emailDetectedByRuleChartOptions?.series?.length &&
			this.gs.areArraysEqual(ruleUsage.labels, this.emailDetectedByRuleChartOptions.xaxis.categories)) {
			this.emailsDetectedChart.updateSeries(series, true);
			return;
		}

		this.emailDetectedByRuleChartOptions = {
			series: series,
			chart: {
				type: ruleUsage.labels?.length === 1 ? 'bar' : 'area',
				height: '100%',
				toolbar: {
					show: false
				},
				animations: {
					animateGradually: {
						enabled: false,
					},
				}
			},
			plotOptions: {
				bar: {
					borderRadius: 5,
					horizontal: false,
					columnWidth: this.gs.getOptimalBarWidth(ruleUsage.labels.length) - 20 + '%',
				},
			},
			colors: ['#8177a3'],
			dataLabels: {
				enabled: false
			},
			stroke: {
				show: true,
				width: 4,
				colors: ['transparent']
			},
			xaxis: {
				categories: ruleUsage.labels,
			},
			yaxis: {
				title: {
					text: 'Emails'
				},
				min: 0,
				labels: {
					formatter: (val) => {
						return val.toFixed(0);
					}
				}
			},
			fill: {
				opacity: 1
			},
			tooltip: {
				y: {
					formatter:  (val) => {
						return val.toFixed(0);
					}
				}
			}
		};
	}

	addCompromisedRuleUsageData(ruleUsage, rulesSourcePerWeek, period) {
		if (rulesSourcePerWeek.dateStart) {
			const dateLabel = this.gs.getPeriodLabel(period, rulesSourcePerWeek);

			ruleUsage.labels.push(dateLabel);
			ruleUsage.data[0].push(rulesSourcePerWeek.total);
		}
	}

	getEmailSenderChartInfo = (emails, isUpdate) => {
		const senderMap = {};
		emails.forEach((emailObj) => {
			if (!senderMap[emailObj.sender]) {
				senderMap[emailObj.sender] = 0;
			}
			senderMap[emailObj.sender]++;
		});
		// @ts-ignore
		const sortedSenders = Object.entries(senderMap).sort((a, b) => b[1] - a[1]);
		const senderGraph = {
			data: [],
			labels: []
		};

		for (let i = 0; i < sortedSenders.length && i < 10; i++) {
			senderGraph.labels.push(sortedSenders[i][0]);
			senderGraph.data.push(sortedSenders[i][1]);
		}

		const series = [{name: "Emails", data: senderGraph.data}];

		if (isUpdate && this.senderGraphOptions?.xaxis?.categories?.length &&
			this.gs.areArraysEqual(senderGraph.labels, this.senderGraphOptions.xaxis.categories)) {
			this.topSendersChart.updateSeries(series, true);
			return;
		}

		this.senderGraphOptions = {
			series: series,
			chart: {
				type: 'bar',
				height: '100%',
				toolbar: {
					show: false
				},
				animations: {
					animateGradually: {
						enabled: false,
					},
				}
			},
			colors: [
				this.lfs.color
			],
			plotOptions: {
				bar: {
					borderRadius: 4,
					horizontal: true,
					barHeight: this.gs.getOptimalBarWidth(senderGraph.labels.length) + '%',
				}
			},
			dataLabels: {
				total: {
					enabled: true,
					offsetX: 0,
					style: {
						fontSize: '13px',
						fontWeight: 900
					}
				}
			},
			xaxis: {
				categories: senderGraph.labels,
			},
			yaxis: {
				labels: {
					align: 'left',
					minWidth: 140,
					maxWidth: 140,
				}
			}
		}
	}

	getEmailRecipientChartInfo = (emails, isUpdate) => {
		const recipientMap = {};
		emails.forEach((emailObj) => {
			if (!recipientMap[emailObj.mailbox_email]) {
				recipientMap[emailObj.mailbox_email] = 0;
			}
			recipientMap[emailObj.mailbox_email]++;
		});
		// @ts-ignore
		const sortedRecipients = Object.entries(recipientMap).sort((a, b) => b[1] - a[1]);
		const recipientGraph = {
			data: [],
			labels: []
		};

		for (let i = 0; i < sortedRecipients.length && i < 10; i++) {
			recipientGraph.labels.push(sortedRecipients[i][0]);
			recipientGraph.data.push(sortedRecipients[i][1]);
		}

		const series = [{
			name: 'Emails',
			data: recipientGraph.data
		}];

		if (isUpdate && this.recipientGraphOptions?.labels?.length &&
			this.gs.areArraysEqual(recipientGraph.labels, this.recipientGraphOptions.xaxis.categories)) {
			this.topRecipientMailboxesChart.updateSeries(series, true);
			return;
		}

		this.recipientGraphOptions = {
			series: series,
			chart: {
				type: 'bar',
				height: '100%',
				toolbar: {
					show: false
				},
				animations: {
					animateGradually: {
						enabled: false,
					},
				}
			},
			colors: [
				this.lfs.color
			],
			plotOptions: {
				bar: {
					borderRadius: 4,
					horizontal: true,
					barHeight: this.gs.getOptimalBarWidth(recipientGraph.labels.length) + '%',
				}
			},
			dataLabels: {
				total: {
					enabled: true,
					offsetX: 0,
					style: {
						fontSize: '13px',
						fontWeight: 900
					}
				}
			},
			xaxis: {
				categories: recipientGraph.labels,
			},
			yaxis: {
				labels: {
					align: 'left',
					minWidth: 140,
					maxWidth: 140,
				}
			},
			tooltip: {
				y: {
					formatter:  (val) => {
						return val.toFixed(0);
					}
				}
			}
		}
	}



	changeViewType = (type) => {
		this.ruleUsagePopup.viewType = type;
	}

	changePeriod = (period) => {
		if (this.ruleUsagePopup.usagePeriod === period) {
			return;
		}
		this.ruleUsagePopup.usagePeriod = period;
		this.getRuleUsage(this.ruleUsagePopup.ruleObj);
	};

	searchRuleEmail =  (searchTxt) => {
		this.ruleUsagePopup.emails.forEach(record => {
			// search
			if (searchTxt) {
				const isFound = searchRuleUsageTextExecute(record, searchTxt);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	}

	copyEmailIdToClipboard =  (email) => {
		this.clipboard.copy(email.message_id);
		this.ruleEmailIdCopied = email.message_id;
	};


	exportRuleEmailsToCsv = (sortBy) => {
		if (!this.ruleUsagePopup.emails || !this.ruleUsagePopup.emails.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}
		let csvString = "Subject,From,Mailbox,Sent,Message ID\n";

		let sortedTable = _.filter(this.ruleUsagePopup.emails,log => {return !log.hide});
		if (sortBy) {
			sortedTable = this.gs.sortTable(sortedTable, sortBy);
		}

		sortedTable.forEach((email) => {
			csvString += `"${email.subject}","${email.sender}",${email.mailbox_email},${email.created},${email.message_id || ''}\n`;
		});

		this.gs.exportCsv(csvString, `compromised_rule_emails.csv`);
	};

	setRuleForEdit = () => {
		let result:any = _.cloneDeep(this.dic.CONSTANTS.accountCompromisedRule.defaultResult);

		result.notify_user.enabled = this.newRule.result.notify_user;
		result.notify_admin.enabled = this.newRule.result.notify_admin;
		result.block_user.enabled = this.newRule.result.block_user;
		result.block_user_24_hours.enabled = this.newRule.result.block_user_24_hours;
		result.risky_user_24_hours.enabled = this.newRule.result.risky_user_24_hours;
		result.reset_password_mail_server.enabled = this.newRule.result.reset_password_mail_server;
		// result.disable_user_mail_server.enabled = this.newRule.result.disable_user_mail_server;
		result.stop_rules.enabled = this.newRule.result.stop_rules;

		this.newRule.result = result;

		this.newRule.conditions = this.parseEditRuleConditions(this.newRule.conditions, false);

		this.newRule.exceptions = this.parseEditRuleConditions(this.newRule.exceptions, true);
	};

	parseEditRuleConditions = (conditions, isException) => {
		return _.map(conditions, conditionArr => {
			conditionArr.forEach(c => {
				if (c.data?.incidentTypes || c.data?.incidentType) {
					c.data.incidentTypes = Object.keys(this.dic.CONSTANTS.accountCompromisedIncidentTypes).map(incidentTypeKey => ({
						key: incidentTypeKey,
						selected: c.data.incidentTypes?.includes(incidentTypeKey),
						...this.dic.CONSTANTS.accountCompromisedIncidentTypes[incidentTypeKey]
					}));
				}
				if (c.data?.incidentType) {
					c.data.selectedIncidentType = {
						key: c.data.incidentType,
						...this.dic.CONSTANTS.accountCompromisedIncidentTypes[c.data.incidentType]
					};
				}
				if (c.data?.users) {
					c.data.users = this.users.map(user => ({
						...user,
						selected: c.data.users?.includes(user.email),
					}));
				}
				c.isException = isException;
			});

			return conditionArr;
		});
	}


	openDeleteRulesPopup(rules) {
		this.gs.showPopup({
			title: `Delete ${rules.length} Rules`,
			subTitle: 'Please note - the selected rules will be deleted.',
			body: ["Rule will not be available for all future emails"],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				this.deleteRules(rules);
			}
		});
	};

	openDeleteRulePopup = (rule) => {
		this.gs.showPopup({
			title: `Delete Rule: ${rule.name}`,
			subTitle: 'Please note - the selected rule will be deleted.',
			body: ["Rule will not be available for all future emails"],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				this.deleteRule(rule);
			}
		});
	};

	deleteRules(rules) {
		let errDelete = 0;
		let deletePromises = [];

		rules.forEach(rule => {
			// Push the delete promise to the array if the rule can be deleted
			let deletePromise = this.rs.deleteAccountCompromisedRule(rule._id).then(res => {
				_.remove(this.rules, {_id: rule._id});
				return true; // Return true to indicate success
			}).catch(err => {
				console.error('Failed to delete rule:', err);
				return false; // Return false on failure
			});

			deletePromises.push(deletePromise);
		});

		Promise.all(deletePromises).then(results => {
			let successDelete = results.filter(result => result).length;
			if (errDelete > 0) {
				this.ns.showErrorMessage(`${errDelete} rules cannot be deleted`);
			}
			if (successDelete > 0) {
				this.ns.showInfoMessage(`${successDelete} rules deleted successfully`);
			}
		}).catch(error => {
			console.error('Error in processing rule deletions:', error);
		});
	}

	deleteRule = (rule) => {
		for (let idx = 0; idx < rule.conditions.length; idx++) {
			let cond = rule.conditions[idx];
		}

		this.rs.deleteAccountCompromisedRule(rule._id).then(res => {
			_.remove(this.rules, {_id: rule._id});
			this.ns.showInfoMessage(this.dic.MESSAGES.ruleDeleted);
		});
	};

	isNameChanged = () => {
		this.ns.closeMessage();
		this.invalidRuleName = false;
	};

	parseNewRuleResult = (lastResult=null) => {
		if (!this.newRule?.result) return;
		this.newRule.resultShow = [];

		_.each(Object.keys(this.newRule.result), key => {
			if (this.newRule.result[key] && this.newRule.result[key].enabled) {
				this.newRule.resultShow.push(this.dic.CONSTANTS.accountCompromisedRule.defaultResult[key].label);
			}
		});
	};

	isResultChanged = (result=null) => {
		this.ns.closeMessage();
		const resultKey = result?.key || result?.name;
		this.parseNewRuleResult(resultKey);
		this.invalidResults = false;
	};

	prepareRuleConditions = (conditions) => {
		let conditionError = false;
		this.newRule.conditionAddresses = [];

		const targetUsersConditions = conditions.flat().filter(c => c.type === this.dic.CONSTANTS.accountCompromisedRule.types.target_users.name);
		if (targetUsersConditions.length > 1) {
			this.ns.showErrorMessage('Only one <b>Incident Target Users</b> condition is allowed in a rule');
			targetUsersConditions.forEach(c => {
				c.invalidConditionType = true;
			});
			conditionError = true;
			return;
		}

		let parsedConditions = _.map(conditions, conditionArr => {
			let data:any = {};

			// handle condition with "OR" connector(s)
			if (conditionArr.length > 1) {
				const orConditionBackendFormat = this.buildOrConditionforBE(conditionArr);
				const parsedOrConditions = this.prepareRuleConditions(orConditionBackendFormat.or_conditions);

				if (parsedOrConditions.error) {
					conditionError = true;
					return;
				}
				else {
					return {
						type: 'or_condition',
						sub_type: 'email',
						data: null,
						is_negate: false,
						or_conditions: parsedOrConditions.conditions
					}
				}
			}
			//

			const c = conditionArr[0] || conditionArr;
			let incidentTypes;

			switch (c.type) {
				case this.dic.CONSTANTS.accountCompromisedRule.types.incident_frequency.name:
					if (!c.data.selectedIncidentType) {
						this.ns.showErrorMessage(util.format(this.dic.ERRORS.emptyField, 'Incident type'));
						conditionError = true;
						c.invalidIncidentType = true;
						return;
					}
					if (!c.data.hours || c.data.hours <= 0 || !Number.isInteger(c.data.hours)) {
						this.ns.showWarnMessage(util.format(this.dic.ERRORS.EnterValidX, 'value for hours (must be a whole number above 0)'));
						conditionError = true;
						c.invalidIncidentHoursSpan = true;
						return;
					}
					if (!c.data.incidentCount || c.data.incidentCount <= 0 || !Number.isInteger(c.data.incidentCount)) {
						this.ns.showWarnMessage(util.format(this.dic.ERRORS.EnterValidX, 'value for incidents count (must be a whole number above 0)'));
						conditionError = true;
						c.invalidIncidentCount = true;
						return;
					}

					data.incidentType = c.data.selectedIncidentType.key;
					data.incidentCount = c.data.incidentCount;
					data.hours = c.data.hours;
					break;

				case this.dic.CONSTANTS.accountCompromisedRule.types.incident_combination.name:
					incidentTypes = c.data.incidentTypes.filter(type => type.selected).map(type => type.key);
					if (!incidentTypes.length) {
						this.ns.showErrorMessage(util.format(this.dic.ERRORS.emptyField, 'Incident types'));
						conditionError = true;
						c.invalidIncidentTypes = true;
						return;
					}
					if (!c.data.hours || c.data.hours <= 0 || !Number.isInteger(c.data.hours)) {
						this.ns.showWarnMessage(util.format(this.dic.ERRORS.EnterValidX, 'value for hours (must be a whole number above 0)'));
						conditionError = true;
						c.invalidIncidentHoursSpan = true;
						return;
					}

					data.incidentTypes = incidentTypes;
					data.hours = c.data.hours;
					break;

				case this.dic.CONSTANTS.accountCompromisedRule.types.target_users.name:
					const incidentUsers = c.data.users.filter(user => user.selected).map(user => user.email);
					if (!incidentUsers.length) {
						this.ns.showErrorMessage(util.format(this.dic.ERRORS.xAtLeastOneX, 'select', 'user'));
						conditionError = true;
						c.invalidIncidentUsers = true;
						return;
					}

					data.users = incidentUsers;
					break;

				case this.dic.CONSTANTS.accountCompromisedRule.types.user_status.name:
					if (!c.data.status?.length) {
						this.ns.showErrorMessage(util.format(this.dic.ERRORS.xAtLeastOneX, 'select', 'status'));
						conditionError = true;
						return;
					}

					data.status =  c.data.status;
					break;
			}

			return {
				type: c.type,
				data: data,
				is_negate: c.is_negate || false
			};
		});
		return {
			error: conditionError,
			conditions: parsedConditions
		};
	};

	// convert or condition from UI structure to BE structure
	buildOrConditionforBE = (conditionArr) => {
		return {
			type: 'or_condition',
			sub_type: 'email',
			data: null,
			is_negate: false,

			or_conditions: conditionArr
		}
	}

	prepareRuleError = () => {
		this.prepareRuleInProcess = false;
	};

	prepareRule = () => {
		if (!this.newRule) {
			return;
		}

		if (!this.newRule.name || this.newRule.name.length > 100) {
			this.ns.showErrorMessage(this.dic.ERRORS.ruleNameInvalid);
			this.prepareRuleError();
			this.invalidRuleName = true;
			return;
		}

		let ruleData:any = {};
		let conditionError;

		let parsedConditions = this.prepareRuleConditions(this.newRule.conditions);
		conditionError = parsedConditions.error;

		if (conditionError) {
			this.prepareRuleError();
			return;
		}

		ruleData.conditions = parsedConditions.conditions;

		parsedConditions = this.prepareRuleConditions(this.newRule.exceptions);
		conditionError = parsedConditions.error;

		if (conditionError) {
			this.prepareRuleError();
			return;
		}

		ruleData.exceptions = parsedConditions.conditions;

		if (this.newRule.resultShow.length === 0) {
			this.prepareRuleError();
			this.invalidResults = true;
			this.ns.showErrorMessage(this.dic.ERRORS.ruleResultNotSelected);
			return;
		}

		ruleData.result = {
			notify_user: this.newRule.result.notify_user.enabled,
			notify_admin: this.newRule.result.notify_admin.enabled,
			block_user: this.newRule.result.block_user.enabled,
			block_user_24_hours: this.newRule.result.block_user_24_hours.enabled,
			risky_user_24_hours: this.newRule.result.risky_user_24_hours.enabled,
			reset_password_mail_server: this.newRule.result.reset_password_mail_server.enabled,
			// disable_user_mail_server: this.newRule.result.disable_user_mail_server.enabled,
			stop_rules: this.newRule.result.stop_rules.enabled,
		};

		ruleData.name = this.newRule.name?.trim();

		this.prepareRuleInProcess = true;

		if (!!this.newRule._id) {
			this.editRule(ruleData);
		}
		else {
			this.addRule(ruleData);
		}
	};

	editRule = (ruleData) => {
		ruleData.action = this.dic.CONSTANTS.accountCompromisedRule.actions.update;

		this.rs.updateAccountCompromisedRule(this.newRule._id, ruleData).then(response => {
			this.rules = response.rules;
			this.resetNewRuleData();
			this.parseRulesResultAndExceptions(this.rules);
		}, err => {
			this.prepareRuleInProcess = false;
		});
	};

	addRule = (ruleData) => {
		this.rs.addAccountCompromisedRule(ruleData).then(response => {
			this.rules = response.rules;
			this.resetNewRuleData();
			this.parseRulesResultAndExceptions(this.rules);
		}, err => {
			this.prepareRuleInProcess = false;
		});
	};


	getRuleConditionText = (condition) => {
		if (!condition) {
			return '';
		}

		condition.text = `<span class="fw-500">${this.dic.CONSTANTS.accountCompromisedRule.types[condition.type].label}</span> `;

		switch (condition.type) {
			case this.dic.CONSTANTS.accountCompromisedRule.types.incident_frequency.name:
				condition.text += `of type <span class="fw-500">${this.dic.CONSTANTS.accountCompromisedIncidentTypes[condition.data.incidentType]?.name}</span> occurs `;
				condition.text += `<span class="fw-500">${condition.data.incidentCount}</span> time${condition.data.incidentCount > 1 ? 's' : ''} `;
				condition.text += `within <span class="fw-500">${condition.data.hours}</span> hour${condition.data.hours > 1 ? 's' : ''}`;
				break;

			case this.dic.CONSTANTS.accountCompromisedRule.types.incident_combination.name:
				condition.text += `of types <span class="fw-500">${(condition.data.incidentTypes || []).map(type => this.dic.CONSTANTS.accountCompromisedIncidentTypes[type]?.name).join(', ')}</span> occurs `;
				condition.text += `within <span class="fw-500">${condition.data.hours}</span> hour${condition.data.hours > 1 ? 's' : ''}`;
				break;

			case this.dic.CONSTANTS.accountCompromisedRule.types.target_users.name:
				condition.text += `are <span class="fw-500">${(condition.data.users || []).join(', ')}</span>`;
				break;

			case this.dic.CONSTANTS.accountCompromisedRule.types.user_status.name:
				condition.text += `is <span class="fw-500">${(condition.data.status)}</span>`;
				break;
		}


		// shorten very long text (keep original for search)
		condition.originalText = condition.text;
		if (condition.text.length > 400) {
			condition.text = condition.text.substring(0,400);
			if (condition.text.lastIndexOf(', ') > -1) {
				condition.text = condition.text.substring(0,condition.text.lastIndexOf(', '));
			}
			condition.text += '...';
		}
		else {
			condition.text += '.';
		}
	};

	searchResults(searchTerm) {
		searchTerm = (searchTerm || '').toLowerCase();

		Object.entries(this.newRule.result).forEach(([key]) => {
			this.newRule.result[key].hide = !this.dic.CONSTANTS.accountCompromisedRule.defaultResult[key]?.label?.toLowerCase().includes(searchTerm);
		});

		this.searchResultNotFound = Object.values(this.newRule.result).every((type: any) => type.hide);
	}


	clearSearchResults() {
		this.searchResultsText = '';
		this.searchResultNotFound = false;
		Object.values(this.newRule.result).forEach((type: any) => {
			type.hide = false;
		});
	}
}

function searchRuleUsageTextExecute(emailObj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((emailObj.sender.toLowerCase().indexOf(searchTerm) > -1) ||
		(emailObj.mailbox_email.toLowerCase().indexOf(searchTerm) > -1) ||
		(emailObj.subject.toLowerCase().indexOf(searchTerm) > -1));
}

function searchTextExecute(rule, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return ((rule.name?.toLowerCase().indexOf(searchTerm) > -1) ||
		_.some(rule.resultShow, result => result?.toLowerCase().indexOf(searchTerm) > -1) ||
		searchTextInConditions(rule.conditions, searchTerm) ||
		searchTextInConditions(rule.exceptions, searchTerm));
}

function searchTextInConditions(conditions, searchTerm) {
	// conditions -> [conditionBundle, AND ,conditionBundle, AND ,conditionBundle...]
	// conditionBundle -> [condition, OR ,condition, OR, condition...]

	for (let i = 0; i < conditions.length; i++) {
		const conditionBundle = conditions[i];

		for (let y = 0; y < conditionBundle.length; y++) {
			const condition = conditionBundle[y];
			const conditionText = htmlTextToText(condition.originalText);

			if (conditionText?.toLowerCase().indexOf(searchTerm) > -1) {
				return true;
			}
		}
	}

	return false;
}

function htmlTextToText(htmlText) {
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = htmlText;
	return tempDiv.innerText;
}
